import { IClassname } from '@/lib/shared/model/classname';

export const KidsRoom = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.8457 23.9228C8.49156 22.2562 9.60431 20.8111 11.0506 19.7607C12.4969 18.7103 14.2154 18.0994 16.0001 18.001C17.7813 18.0817 19.4978 18.6922 20.9299 19.7543C22.3622 20.8162 23.4449 22.2815 24.0395 23.9625"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.32613 22.7847C5.29244 20.3174 6.85137 18.126 8.86529 16.404L7.05448 9.69492L4.75423 10.4617C4.04386 10.5955 3.30914 10.458 2.69517 10.0765C2.08122 9.69491 1.63267 9.09699 1.43812 8.4008C1.24356 7.70462 1.31715 6.96078 1.64435 6.31621C1.97155 5.67165 2.52857 5.17321 3.20539 4.91935L7.28706 3.07659C7.90449 2.79881 8.60692 2.77736 9.24015 3.01694C9.87338 3.25654 10.3857 3.73758 10.6646 4.35451L12.8051 9.05596H19.1947C20.5504 9.05596 21.8506 9.59452 22.8091 10.5531C23.7678 11.5118 24.3064 12.8119 24.3064 14.1677V17.5222C25.1319 17.8647 26.8213 20.4244 27.6749 22.7898"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0056 10.7617L29.9511 14.7003"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8052 9.05566L13.9553 13.683C13.9898 13.8213 14.0695 13.9441 14.1819 14.0319C14.2941 14.1196 14.4326 14.1672 14.5751 14.1674H18.051C18.1935 14.1672 18.332 14.1196 18.4442 14.0319C18.5566 13.9441 18.6363 13.8213 18.6708 13.683L19.8209 9.094"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.009 30.1493C11.5343 30.1562 7.09831 29.3217 2.93206 27.6893C2.29963 27.4415 1.79152 26.9527 1.51951 26.3304C1.2475 25.7079 1.23387 25.003 1.48162 24.3706C1.72938 23.7381 2.21821 23.23 2.8406 22.9579C3.46299 22.686 4.16794 22.6723 4.80037 22.9201C12.0054 25.7144 19.9943 25.7167 27.201 22.9265C27.8334 22.6791 28.5382 22.693 29.1604 22.9652C29.7825 23.2376 30.2711 23.7458 30.5185 24.3782C30.7659 25.0107 30.7519 25.7154 30.4796 26.3376C30.2074 26.9597 29.6992 27.4483 29.0667 27.6957C24.9062 29.324 20.4768 30.1563 16.009 30.1493Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60156 2.96519L9.80214 2.07959C10.5825 1.76744 11.4544 1.77537 12.2289 2.10163C13.0035 2.42791 13.6182 3.04626 13.94 3.82267L16.1125 9.06213"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41689 6.81962C6.24045 6.81962 6.09741 6.67659 6.09741 6.50014C6.09741 6.3237 6.24045 6.18066 6.41689 6.18066"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M6.41699 6.81962C6.59343 6.81962 6.73647 6.67659 6.73647 6.50014C6.73647 6.3237 6.59343 6.18066 6.41699 6.18066"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
